import { AceRecord } from "@cs124/monace";
import { Array, Boolean, InstanceOf, Literal, Number, Record, String } from "runtypes";
import { Languages } from "./languages";
export const VideoContent = Record({
  type: Literal("video"),
  kind: Literal("youtube"),
  videoID: String,
  private: Boolean
});
export const NewVideoContent = VideoContent.And(
  Record({
    duration: Number
  })
);
export const WalkthroughContent = Record({
  type: Literal("walkthrough"),
  transcript: Boolean
});
export const NewWalkthroughContent = Record({
  type: Literal("walkthrough"),
  trace: Array(AceRecord)
});
export const NewContent = Record({
  path: String,
  language: Languages,
  content: NewVideoContent.Or(NewWalkthroughContent)
});
export const Sources = Literal("cs124.org").Or(Literal("learncs.online"));
export const Shareable = Record({
  type: Literal("content"),
  path: String,
  language: Languages,
  id: String,
  duration: Number,
  content: VideoContent.Or(WalkthroughContent),
  email: String,
  name: String,
  created: InstanceOf(Date).Or(String),
  instructor: Boolean,
  disabled: Boolean,
  source: Sources
});
export const WalkthroughTrace = Record({
  id: String,
  trace: Array(AceRecord),
  duration: Number
});
//# sourceMappingURL=content.js.map
